import PaymentSurcharge from './payment_surcharge';

export default PaymentSurcharge;
